import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from "react";
import { TextField as MuiTextField } from "@mui/material";
import { SurveyInputTypeEnum, TextUpdateMode, } from "../../../../types/forms";
import { useInputMask } from "../../hooks/useInputMask";
import { shouldSaveMaskedValue } from "../../utils/mask-utils";
var MaskedTextField = function (_a) {
    var mask = _a.mask, element = _a.element, field = _a.field, error = _a.error, isEnabled = _a.isEnabled, textUpdateMode = _a.textUpdateMode;
    var pendingValueRef = useRef(null);
    var _b = useInputMask({
        mask: mask,
        onValueChange: function (maskedValue, unmaskedValue) {
            if (textUpdateMode === TextUpdateMode.ON_TYPING) {
                field.onChange(shouldSaveMaskedValue(element) ? maskedValue : unmaskedValue);
                return;
            }
            pendingValueRef.current = {
                masked: maskedValue,
                unmasked: unmaskedValue,
            };
        },
    }), inputRef = _b.inputRef, setDisplayValue = _b.setDisplayValue;
    var displayValue = useMemo(function () { var _a; return mask.getMaskedValue((_a = field.value) !== null && _a !== void 0 ? _a : ""); }, [mask, field.value]);
    useEffect(function () {
        setDisplayValue(displayValue);
    }, [displayValue, setDisplayValue]);
    var commitPending = function () {
        if (textUpdateMode === TextUpdateMode.ON_BLUR && pendingValueRef.current) {
            var _a = pendingValueRef.current, masked = _a.masked, unmasked = _a.unmasked;
            field.onChange(shouldSaveMaskedValue(element) ? masked : unmasked);
            pendingValueRef.current = null;
        }
    };
    var handleBlur = function () {
        commitPending();
        field.onBlur();
    };
    var handleKeyDown = function (e) {
        if (e.key === "Enter") {
            commitPending();
        }
    };
    return (_jsx(MuiTextField, { fullWidth: true, name: field.name, inputRef: function (node) {
            inputRef.current = node;
            field.ref(node);
        }, onBlur: handleBlur, onKeyDown: handleKeyDown, type: element.inputType || SurveyInputTypeEnum.TEXT, placeholder: element.placeholder, autoComplete: element.autocomplete, error: !!error, helperText: error === null || error === void 0 ? void 0 : error.message, disabled: !isEnabled }));
};
export default MaskedTextField;
